/* global axios */
import ApiClient from './ApiClient';

class GoogleAdsAPI extends ApiClient {
  constructor() {
    super('google_ads_connections', { accountScoped: true });
  }

  generateAuthorization() {
    return axios.post(`${this.baseUrl()}/google_ads/authorization`);
  }

  customers(id) {
    return axios.get(`${this.url}/${id}/customers`);
  }

  conversionActions(id) {
    return axios.get(`${this.url}/${id}/conversion_actions`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { google_ads_connection: data });
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }

  getAudiences() {
    return axios.get(`${this.baseUrl()}/google_ads/audiences`);
  }

  createAudience(payload) {
    return axios.post(`${this.baseUrl()}/google_ads/audiences`, payload);
  }

  syncAudience(id) {
    return axios.post(`${this.baseUrl()}/google_ads/audiences/${id}/sync`);
  }

  deleteAudience(id) {
    return axios.delete(`${this.baseUrl()}/google_ads/audiences/${id}`);
  }

  insights(connectionId, dateRange) {
    return axios.get(`${this.baseUrl()}/google_ads/insights`, {
      params: { connection_id: connectionId, date_range: dateRange },
    });
  }
}

export default new GoogleAdsAPI();
